'use client';
import * as React from "react";
import { renderDrawerHeader_unstable } from "@fluentui/react-drawer";
import { useCustomStyleHook_unstable } from "@fluentui/react-shared-contexts";
import { useNavDrawerHeaderStyles_unstable } from "./useNavDrawerHeaderStyles.styles.js";
import { useNavDrawerHeader_unstable } from "./useNavDrawerHeader.js";
/**
 * NavDrawerHeader component
 */ export const NavDrawerHeader = /*#__PURE__*/ React.forwardRef((props, ref)=>{
    const state = useNavDrawerHeader_unstable(props, ref);
    useNavDrawerHeaderStyles_unstable(state);
    useCustomStyleHook_unstable('useNavDrawerHeaderStyles_unstable')(state);
    return renderDrawerHeader_unstable(state);
});
NavDrawerHeader.displayName = 'NavDrawerHeader';
